import React from 'react';
import { createSvgIcon } from '@material-ui/core/utils';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M19.116 8.218h1.134v7.564h-1.134v-.987h-7.224l-.227.272a7.292 7.292 0 01-1.032 1.111v-3.119l-6.884-1.055 6.884-1.089V7.819c.385.34.748.726 1.032 1.111l.227.272h7.224v-.987z"
}), 'Unpin');